import { UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const recruitingSubNav: RouteListItem[] = [
  {
    path: '/recruiting/$id',
    icon: UserCircle,
    name: 'Recruiting',
  },
];
